import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bookName', 'bookSelect', 'chapterSelect']
  static values = { chaptersUrl: String, readChapters: Object }

  async changeBook () {
    const bookId = this.bookSelectTarget.value
    this.bookNameTarget.value = this.selectedBookName()
    this.resetChapters()

    if (!bookId) return

    const response = await fetch(this.chaptersUrlValue.replace('__BOOK_ID__', bookId), {
      headers: { Accept: 'application/json' }
    })
    if (!response.ok) return

    const chapters = await response.json()
    chapters
      .filter((chapter) => !this.readChapterNumbers(bookId).includes(Number(chapter.chapter)))
      .forEach((chapter) => {
        const option = document.createElement('option')
        option.value = chapter.chapter
        option.textContent = chapter.chapter
        this.chapterSelectTarget.appendChild(option)
      })
  }

  readChapterNumbers (bookId) {
    if (!this.hasReadChaptersValue) return []

    return this.readChaptersValue[bookId] || []
  }

  resetChapters () {
    this.chapterSelectTarget.innerHTML = ''
    const option = document.createElement('option')
    option.value = ''
    option.textContent = 'Choose chapter'
    this.chapterSelectTarget.appendChild(option)
  }

  selectedBookName () {
    const option = this.bookSelectTarget.selectedOptions[0]
    return option && option.value ? option.textContent : ''
  }

  submitChapter () {
    if (this.chapterSelectTarget.value) {
      this.element.requestSubmit()
    }
  }
}
